import React, { useCallback, useEffect, forwardRef, useState } from "react";
import { Form, Input, InputNumber, Select, Switch } from "antd";
import slugify from "slugify";
import { useSelector, useDispatch } from "react-redux";
import categoryApi from "../../api/product/categoryApi";
import UploadFile from "../../components/UploadFile";
import { fileManagerActions } from "../../store";

const ProductInfo = forwardRef((props, ref) => {
  const { Option } = Select;
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const [lstCategory, setLstCategory] = useState([]);

  const { fileImageUrl } = useSelector((x) => x.fileManager);

  const [valueForm, setValueForm] = useState({
    published: true,
    categoryId: null,
    tags: [],
    name: null,
    slug: null,
    sku: null,
    quantity: 0,
    weight: 0,
    long: 0,
    width: 0,
    height: 0,
    allowPreview: false,
    shortUse: null,
  });

  useEffect(() => {
    getCategories();
    form.setFieldsValue(valueForm);
    setImageNull(null);
  }, [form]);

  useEffect(() => {
    const productItem = props.productItem;
    if (productItem) {
      const categoryId =
        lstCategory.filter((a) => a.id == productItem.category).length > 0
          ? productItem.category
          : null;
      form.setFieldsValue({
        published: productItem.published,
        categoryId: categoryId,
        tags: productItem.tags,
        name: productItem.name,
        slug: productItem.slug,
        sku: productItem.sku,
        quantity: productItem.quantity,
        weight: productItem.weight ? productItem.weight : 0,
        long: productItem.long ? productItem.long : 0,
        width: productItem.width ? productItem.width : 0,
        height: productItem.height ? productItem.height : 0,
        allowPreview: productItem.allowPreview,
        shortUse: productItem.shortUse,
      });
      setImageNull(productItem.avatar);
    } else {
      form.setFieldsValue(valueForm);
      setImageNull(null);
    }
  }, [lstCategory]);

  const setImageNull = (url) => {
    dispatch(fileManagerActions.setUrlImageUp(url));
  };

  const getCategories = () => {
    const params = {
      display: true,
      page: 1,
      limit: 1000,
    };
    categoryApi.getCategories(params).then((res, status) => {
      if (res.results) {
        const data = res.results;
        setLstCategory(data);
      }
    });
  };

  const titleChange = useCallback(
    (values) => {
      const slug = slugify(values).toLowerCase();
      form.setFieldsValue({
        slug: slug,
      });
    },
    [form]
  );

  const onFinishFailed = (errorInfo) => {
    props.onFinishFailed({
      errorFields: errorInfo.errorFields,
      name: "ProductInfo",
    });
    console.log("Failed:", errorInfo);
  };

  const onFinish = (values) => {
    props.onSubmit({ ...values, avatar: fileImageUrl }, "ProductInfo");
  };

  return (
    <>
      <Form
        form={form}
        labelCol={{
          span: 4,
        }}
        wrapperCol={{
          span: 14,
        }}
        ref={ref}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="horizontal"
        size="large"
      >
        <Form.Item
          label="Published"
          name="published"
          valuePropName="checked"
          tooltip="Trạng thái đăng tải của sản phẩm"
        >
          <Switch defaultChecked />
        </Form.Item>

        <Form.Item label="Ảnh hiển thị" name="avatar">
          <UploadFile />
        </Form.Item>

        <Form.Item
          label="Danh mục"
          name="categoryId"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn danh mục!",
            },
          ]}
        >
          <Select
            showArrow
            showSearch
            size="large"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            placeholder="Chọn..."
          >
            {lstCategory == null ||
            lstCategory === "undefined" ||
            lstCategory === []
              ? []
              : lstCategory.map((item, key) => (
                  <Option key={key} value={item.id}>
                    {item.name}
                  </Option>
                ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Tag"
          name="tags"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn tags!",
            },
          ]}
        >
          <Select
            mode="tags"
            showArrow
            style={{ width: "100%" }}
            placeholder="Chọn tags .."
            size="large"
          ></Select>
        </Form.Item>

        <Form.Item
          label="Tên sản phẩm"
          name="name"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập tên sản phẩm!",
            },
          ]}
          onChange={(e) => {
            titleChange(e.target.value);
          }}
        >
          <Input />
        </Form.Item>

        <Form.Item label="Mô tả ngắn công dụng" name="shortUse">
          <Input />
        </Form.Item>

        <Form.Item
          label="Slug"
          name="slug"
          onChange={(e) => {
            titleChange(e.target.value);
          }}
          rules={[
            {
              required: true,
              message: "Thiếu dữ liệu!",
            },
            {
              pattern: new RegExp(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
              message: "Slug không đúng định dạng!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="SKU"
          name="sku"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập SKU!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Số lượng"
          name="quantity"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập số lượng!",
            },
          ]}
        >
          <InputNumber min={0} />
        </Form.Item>
        <Form.Item
          label="Cho phép đánh giá"
          valuePropName="checked"
          name="allowPreview"
        >
          <Switch defaultChecked />
        </Form.Item>

        <Form.Item label="Cân nặng" name="weight">
          <InputNumber min={0} addonAfter="Kg" />
        </Form.Item>
        <Form.Item label="Chiều dài" name="long">
          <InputNumber min={0} addonAfter="Cm" />
        </Form.Item>
        <Form.Item label="Chiều rộng" name="width">
          <InputNumber min={0} addonAfter="Cm" />
        </Form.Item>
        <Form.Item label="Chiều cao" name="height">
          <InputNumber min={0} addonAfter="Cm" />
        </Form.Item>
      </Form>
    </>
  );
});

export default ProductInfo;
